// extracted by mini-css-extract-plugin
export default {"toast":"SMLUndoToast_toast__+p2fj","icon":"SMLUndoToast_icon__wEc0u","text":"SMLUndoToast_text__zzA+h","undo":"SMLUndoToast_undo__xJFsF","close":"SMLUndoToast_close__-ASkG"};